import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Button,
    Menu,
    MenuItem,
    Chip
} from "@mui/material";

import CalendarTodayOutlined from "@mui/icons-material/CalendarTodayOutlined";
import { Row } from "react-bootstrap";

const BatchProcessingStatus = () => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (
        <Card className="h-100" sx={{ borderRadius: "3px",    border: "1px solid #eee",
 }}>
            <CardContent>

                {/* HEADER */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3} >
                   <h6 fontSize={17}  ><strong>Batch Processing Status</strong></h6>

                    <Button
                        onClick={handleClick}
                        variant="outlined"
                        startIcon={<CalendarTodayOutlined fontSize="small" />}
                        sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            color: "#111",
                            borderColor: "#ddd"
                        }}
                    >
                        Monthly
                    </Button>

                    <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                        <MenuItem onClick={handleClose}>Daily Report</MenuItem>
                        <MenuItem onClick={handleClose}>Weekly Report</MenuItem>
                        <MenuItem onClick={handleClose}>Monthly Report</MenuItem>
                        <MenuItem onClick={handleClose}>Yearly Report</MenuItem>
                    </Menu>
                </Box>

                {/* TOTAL */}
                <Box mb={3}>
                    <Typography color="text.secondary">Combined Total</Typography>

                    <Box display="flex" alignItems="center" gap={2}>
                        <Typography fontSize={26} fontWeight={600}>
                            $2,459,320
                        </Typography>

                        <Chip
                            label="3 Batches"
                            size="small"
                            sx={{
                                bgcolor: "#e6f4ea",
                                color: "#1e8e3e",
                                fontWeight: 500
                            }}
                        />
                    </Box>
                </Box>

                {/* PROCESS CHART */}
                {/* PROCESS CHART */}
                <Box className="overflow-x-scroll" sx={{ display: "flex", mt: 3 }}>

                    {/* SECTION 1 */}
                    <Box sx={{ flex: 1, display: "flex" }}>
                        <Box
                            sx={{
                                width: 16,
                                display: "flex",
                                justifyContent: "center"
                            }}
                        >
                            <Box
                                sx={{
                                     
                                    borderLeft: "2px dashed #e0e0e0",
                                    height: "100%"
                                }}
                            />
                        </Box>

                        <Box textAlign="center" flex={1} pl={2}>
              
                                <Typography fontSize={12} fontWeight={600}>1120 Employees</Typography> {}
                            <Typography color="text.secondary">$2,184,500</Typography>


                            <Box
                                sx={{
                                    mt: 8,
                                    height: 50,
                                    borderRadius: 25,
                                    bgcolor: "#f26522"
                                }}
                            />
                        </Box>
                    </Box>


                    {/* SECTION 2 */}
                    <Box sx={{ flex: 1, display: "flex" }}>
                        <Box sx={{ width: 16, display: "flex", justifyContent: "center" }}>
                            <Box sx={{ borderLeft: "2px dashed #e0e0e0", height: "100%" }} />
                        </Box>

                        <Box textAlign="center" flex={1} pl={2}>
                            <Typography fontSize={12} fontWeight={600}>1120 Employees</Typography> {}
                            <Typography color="text.secondary">$2,184,500</Typography>



                            <Box
                                sx={{
                                    mt: 8,
                                    height: 50,
                                    borderRadius: 25,
                                    bgcolor: "#0f4c5c"
                                }}
                            />
                        </Box>
                    </Box>


                    {/* SECTION 3 */}
                    <Box sx={{ flex: 1, display: "flex" }}>
                        <Box sx={{ width: 16, display: "flex", justifyContent: "center" }}>
                            <Box sx={{ borderLeft: "2px dashed #e0e0e0", height: "100%" }} />
                        </Box>

                        <Box textAlign="center" flex={1} pl={2}>
                              <Typography fontSize={12} fontWeight={600}>1120 Employees</Typography> {}
                            <Typography color="text.secondary">$2,184,500</Typography>


                            <Box 
                                sx={{
                                    mt: 8,
                                    height: 50,
                                    borderRadius: 25,
                                    bgcolor: "#1c1f26"
                                }}
                            />
                        </Box>
                    </Box>

                </Box>

                {/* LEGEND */}
                <Box display="flex" gap={3} flexWrap="wrap">

                    <Box display="flex" alignItems="center" gap={1}>
                        <Box width={10} height={10} borderRadius="50%" bgcolor="#f26522" />
                        <Typography fontSize={13}>Full Time</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                        <Box width={10} height={10} borderRadius="50%" bgcolor="#0f4c5c" />
                        <Typography fontSize={13}>Part Time</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1}>
                        <Box width={10} height={10} borderRadius="50%" bgcolor="#1c1f26" />
                        <Typography fontSize={13}>Contractors</Typography>
                    </Box>

                </Box>

            </CardContent>
        </Card>
    );
};

export default BatchProcessingStatus;